/* global axios */
import ApiClient from './ApiClient';

class OrdersAPI extends ApiClient {
  constructor() {
    super('orders', { accountScoped: true });
  }

  create({ conversationId, orderInfo }) {
    return axios.post(this.url, { conversation_id: conversationId, order_info: orderInfo });
  }
}

export default new OrdersAPI();
